
export default {
  methods: {
    closeSearch() {
      this.$emit("close-search");
    },
  },
};
